import React from 'react';
import { connect } from 'react-redux';
import { isPristine } from 'redux-form';
import p from '../../style/portalStyle';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import {
  saveAnalysisClientOnly,
  saveCaseLevelAnalysisClientOnly,
  selectPathologist,
  toggleForm,
} from '../../redux/actions';
import { userRoles } from "../../constants";
import { buildSpecimenFormId, buildCaseFormId } from '../../helpers/formIdCreator';


const PathologistDropdown = (props) => {

  const {
    assignedPathologists,
    isSpecimenLevel,
    selectedSpecimen,
    pristine,
    currentPathologist,
    selectedCase,
    toggleForm,
    user,
    selectPathologist,
    unsavedAnalyzes,
  } = props;

  const createDropDownEntriesForSpecimenView = () => {
    if (!assignedPathologists) return;

    return assignedPathologists.map(pathologist => {

      const formId = isSpecimenLevel
        ? buildSpecimenFormId(selectedSpecimen, pathologist)
        : buildCaseFormId(selectedCase, pathologist);

      const shouldBeFlagged = unsavedAnalyzes.some(a => a.formId === formId);

      const menuItem = {
        width: '300px',
        backgroundColor:
          shouldBeFlagged /* ||
            (!pristine && pathologist === currentPathologist) */
            ? 'red'
            : 'white',
        padding: '0px',
      };
      return (
        <MenuItem
          key={pathologist._id}
          value={pathologist}
          primaryText={pathologist.name}
          style={menuItem}
        />
      );

    })

  };

  const handleChange = () => {

    if (!pristine) {
      //the temp save is causing LOTS of bugs
      // TODO fix temp save and then if needed, uncomment ....

      /*       const saveFunction = isSpecimenLevel ? saveAnalysisClientOnly : saveCaseLevelAnalysisClientOnly;
            const selectedId = isSpecimenLevel ? selectedSpecimen.id : selectedCase.id
            const values = form.caseSpecimenForm.values
            saveFunction(values, currentPathologist, selectedId); */
      toggleForm();
    }
  };



  const handleDropDownMenu = () => {
    const userIsPathologist = [userRoles.pathologist, userRoles.val_pathologist].includes(user.role)
    //const userIsPathologist = user.role === userRoles.pathologist
    // || user.role === userRoles.val_pathologist;

    // Redux form strikes again: apparently if the dropdown menu is not present in portal in some capacity (i.e hidden or none
    // then the textfields in the form will not register. Fun shit.

    const style = userIsPathologist ? { display: 'none' } : p.menuChosenPathologist;
    return (
      <div className="phatologist-dropdown-component" style={style}>
        <div style={p.pathologistMenuPTag}>
          <p>Pathologist:</p>
        </div>
        <DropDownMenu
          value={currentPathologist}
          style={p.dropDownMenuPathologists}
          // iconStyle={{display: 'none'}}
          // labelStyle={{color: '#777', fontSize: '12px'}}
          onChange={(e, index, obj) => {
            handleChange();
            selectPathologist(obj);
          }}
        >
          {createDropDownEntriesForSpecimenView()}
        </DropDownMenu>
      </div>
    );

  };

  return <div>{handleDropDownMenu()}</div>;
};

const mapStateToProps = (state) => {
  const { auth, _case, form } = state;
  const pristine = isPristine('caseSpecimenForm')(state);
  const { user } = auth;
  const {
    assignedPathologists,
    currentPathologist,
    selectedSpecimen,
    specimens,
    selectedCase,
    cases,
    unsavedAnalyzes,
  } = _case;
  const currentCase = cases.find((item) => item.id === selectedCase.id);
  return {
    user,
    currentCase,
    assignedPathologists,
    currentPathologist,
    selectedSpecimen,
    form,
    pristine,
    specimens,
    selectedCase,
    unsavedAnalyzes,
  };
};

export default connect(
  mapStateToProps,
  {
    selectPathologist,
    saveAnalysisClientOnly,
    saveCaseLevelAnalysisClientOnly,
    toggleForm,
  },
)(PathologistDropdown);
